import { fromJS } from 'immutable';

import {
  currentUserUpdatedType,
  setActiveResultsType,
  setIsAEMockType,
  setUserDropdownOpenType,
  isLoggedInUserDropdownOpenKey,
  isPersonalizationUserDropdownOpenKey,
} from './HeaderComponentConstants';

export const initialState = fromJS({
  currentUser: null,
  activeResults: null,
  isAEMock: null,
  userDropdownsOpen: {
    [isLoggedInUserDropdownOpenKey]: false,
    [isPersonalizationUserDropdownOpenKey]: false,
  },
});

// eslint-disable-next-line default-param-last
export function reducer(state = initialState, action) {
  switch (action.type) {
    case currentUserUpdatedType: {
      const { currentUser } = action;
      return state.set('currentUser', currentUser);
    }
    case setActiveResultsType: {
      const { activeResults } = action;
      return state.set('activeResults', activeResults);
    }
    case setIsAEMockType: {
      const { isAEMock } = action;
      return state.set('isAEMock', isAEMock);
    }
    case setUserDropdownOpenType: {
      const { isUserDropdownOpen, key } = action;
      return state.setIn(['userDropdownsOpen', key], isUserDropdownOpen);
    }
    default: {
      return state;
    }
  }
}
